// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2kH7a","signatureButtonsRight":"ModalSign_signatureButtonsRight__2GKnx"};